import React, { useState, useEffect } from 'react'
import { useDispatch, useSelector } from 'react-redux';
import { Grid } from '@mui/material';

import CustomerDashboard from '../CustomerDashboard';

import { openDrawer } from './../../../store/slice/MenuSlice';

export default function CustomerPage() {
    const dispatch = useDispatch();
    const { CustomerList} = useSelector((state)=>state.dmpaslice)
    useEffect(() => {
        dispatch(openDrawer(false));
    },[]);

    return (
        < CustomerDashboard />
    )

}